module.exports = __webpack_public_path__ + "img/adulto47.db462d3c.jpg";